// @flow
import { path } from 'ramda'
import { getChannelLanguages } from '@alphaott/api-client'
import { getPublicDomain, getCacheChannels, isCacheValid } from '@alphaott/app-main/selectors'

export const FETCH_CHANNEL_LANGUAGES = 'channels/FETCH_LANGUAGES'

const fetchChannelLanguagesAction = (serviceSpec: string) => (dispatch: Function, getState: Function) => {
  const state = getState()
  const publicApi = getPublicDomain(state)
  const ttl = getCacheChannels(state)

  return dispatch({
    type: FETCH_CHANNEL_LANGUAGES,
    payload: getChannelLanguages(publicApi, serviceSpec),
    meta: { ttl },
  })
}

// eslint-disable-next-line complexity
export const fetchChannelLanguages = (serviceSpec: string, force: ?boolean = false) => (
  dispatch: Function,
  getState: Function,
) => {
  if (force) return dispatch(fetchChannelLanguagesAction(serviceSpec))

  const state = getState()
  const expires = path(['channelLanguages', 'expires'], state)

  if (expires && isCacheValid(expires)) return null

  return dispatch(fetchChannelLanguagesAction(serviceSpec))
}
